<template>
  <div v-if="loading_page === true">
    <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
      <v-skeleton-loader type="article, actions"></v-skeleton-loader>
    </v-sheet>
  </div>
  <div v-else>
    <v-row>
      <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
        <div class="title_page ma-3">
          <h4 class="breadcrumb_title_page">รายการทีมงาน</h4>
          <v-breadcrumbs :items="sub_menu">
            <template v-slot:divider>
              <v-icon>mdi-chevron-right</v-icon>
            </template>
          </v-breadcrumbs>
        </div>
      </v-col>
      <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
        <div class="title_page ma-3">
          <v-btn v-if="this.tab_id == 1" type="button" class="btn_add_data" elevation="4"
            @click="link('/arin/adminlist/addemployee')" large>เพิ่มพนักงาน</v-btn>
          <v-btn v-else type="button" class="btn_add_data" elevation="4" @click="link('/arin/adminlist/addemployee')"
            large>เพิ่มผู้ดูแลระบบ</v-btn>
        </div>
      </v-col>
    </v-row>

    <v-card elevation="4">
      <v-card-text>
        <v-row>
          <v-col xs="12" sm="6" md="8" lg="8" xl="8" cols="12">
            <v-tabs color="#D6BFAF">
              <v-tab @click="tabs(1)">พนักงาน</v-tab>
              <v-tab @click="tabs(0)">ผู้ดูแลระบบ</v-tab>
            </v-tabs>
          </v-col>
          <v-col xs="12" sm="6" md="4" lg="4" xl="4" cols="12">
            <v-text-field color="#D6BFAF" class="input-radius" append-icon="mdi-magnify" hide-details="auto"
              v-model="search" placeholder="ค้นหา..." single-line outlined dense></v-text-field>
          </v-col>
        </v-row>
        <v-divider class="mx-4"></v-divider>
        <div class="mt-3">
          <v-data-table :headers="headers" :items="employess_list" :search="search" :footer-props="footer_Props"
            mobile-breakpoint="0">
            <template v-slot:item="dataDetail">
              <tr>
                <td class="pa-3 hidden_line">
                  <div class="table-data-img-center" v-if="dataDetail.item.picture">
                    <v-img height="80" max-width="80" :lazy-src="dataDetail.item.picture" :src="dataDetail.item.picture"
                      class="preview"></v-img>
                  </div>
                  <div class="table-data-img-center" v-else>
                    <v-img height="80" max-width="80" :lazy-src="img_holder_cert" :src="img_holder_cert"
                      class="preview"></v-img>
                  </div>
                </td>
                <td class="hidden_line">
                  <div>{{ dataDetail.item.em_code }}</div>
                </td>
                <td class="hidden_line">
                  <div>{{ dataDetail.item.name }} [{{ dataDetail.item.store_name }}]</div>
                </td>
                <td class="hidden_line">
                  <div>{{ dataDetail.item.tel }}</div>
                </td>
                <td class="hidden_line">
                  <v-switch v-model="dataDetail.item.status"
                    @click="swicht_status(dataDetail.item.id, dataDetail.item.status);" color="success"
                    inset></v-switch>
                </td>
                <td class="hidden_line">
                  <v-btn elevation="4" class="ma-2" outlined color="#8EBBDC" title="ดูรายละเอียด" height="45" small
                    style="border-radius:10px" @click="link('/arin/adminlist/detailemployee/' + dataDetail.item.id)">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                  <v-btn elevation="4" class="ma-2" outlined color="#FEA06C" title="แก้ไขรายละเอียด" height="45" small
                    @click="link('/arin/adminlist/editemployee/' + dataDetail.item.id)" style="border-radius:10px">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>

                  <v-btn elevation="4" class="ma-2" outlined color="error" title="ลบข้อมูล" height="45" small style="border-radius:10px"
                    @click="deleteEmployee(dataDetail.item.id)">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>


<script>
import img_holder from "@/assets/arin_assets/image_profile.png";
import img_holder_cert from "@/assets/arin_assets/logo_user.png";
import { HTTP_ARIN } from "@/axios_arin";
import Swal from "sweetalert2";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Admin_list",
  data() {
    return {
      loading_page: false,
      search: '',
      img_holder: img_holder,
      img_holder_cert: img_holder_cert,
      switch1: true,
      tab_id: 1,
      footer_Props: {
        'items-per-page-text': 'รายการต่อหน้า'
      },
      employess_list: [],
      tab_main: [
        'พนักงาน', 'ผู้ดูแลระบบ'
      ],
      sub_menu: [
        {
          text: 'ทีมงาน',
          disabled: false,
        },
      ],
      headers: [
        {
          text: 'รูปภาพทีมงาน',
          value: '',
          fixed: true,
          width: '150px',
          align: 'center',
          font: '14px',

        },
        {
          text: 'รหัสทีมงาน',
          value: 'em_code',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ชื่อทีมงาน',
          value: 'name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'เบอร์โทร',
          value: 'tel',
          fixed: true,
          width: '180px',
        },
        {
          text: 'สถานะ',
          value: 'status',
          fixed: true,
          sortable: false,
          width: '120px',
        },
        {
          text: 'จัดการ',
          value: '',
          fixed: true,
          sortable: false,
          width: '200px',
        },
      ],

    }
  },
  methods: {
    // GET ข้อมูลพนักงาน
    async getEmployeeList() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      await HTTP_ARIN.get('/employee/detail/' + this.$store.state.store_arin.user_data.store_id, config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.employess_list = res.data.employeeList;
        }
      })
    },
    async swicht_status(id, checked) {
      let status = 0;
      if (checked === true) {
        status = 1;
      } else {
        status = 0;
      }

      let config = {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
        }
      };
      await  HTTP_ARIN.get('/employee/statusEmp/' + status + '/' + id, config).then(() => { });
    },
    // ลบข้อมูลพนักงาน
    deleteEmployee(evt) {
      Swal.fire({
        title: 'คุณแน่ใจไหม?',
        text: "หากลบข้อมูลแล้วคุณจะกู้ข้อมูลกลับไม่ได้!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ใช่, ลบข้อมูล',
        cancelButtonText: 'ยกเลิก',
      }).then((result) => {
        if (result.isConfirmed) {
          let config = {
            headers: {
              'Content-Type': 'application/json',
              "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
            }
          };
          HTTP_ARIN.get('/employee/delete/' + evt, config).then((res) => {
            if (res.data.successful === true) {
              let timerInterval
              Swal.fire({
                title: 'เสร็จสิ้น',
                text: 'ลบข้อมูลเรียบร้อยแล้ว',
                icon: 'success',
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading()
                  timerInterval = setInterval(() => { })
                },
                willClose: () => {
                  clearInterval(timerInterval)
                  setTimeout(function () {
                    window.location.href = '/arin/adminlist';
                  });
                }
              })
            }
            else {
              Swal.fire({
                title: 'แจ้งเตือน',
                text: 'ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง!',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              });
            }
          })
        }
      })
    },
    link(link) {
      window.location.href = link;
    },
    edit_employee() {
      this.$router.push('/arin/adminlist/editemployee')
    },
    detail_employee() {
      this.$router.push('/arin/adminlist/detailemployee')
    },
    async tabs(number) {
      this.tab_id = number
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
     await HTTP_ARIN.get('/employee/detail/' + this.$store.state.store_arin.user_data.store_id, config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.employess_list = res.data.employeeList;
          let value = res.data.employeeList.filter((res) => {
            return res.claim_status == number
          });
          this.employess_list = value;
        }
      })
    },
  },
  async mounted() {
    await this.getEmployeeList()
    await this.tabs(1)
  }
}
</script>

<style scoped>
.title_page h4.breadcrumb_title_page {
  font-size: 20px !important;
}

.v-timeline::before {
  top: 55px;
  height: calc(100% - 80px);
}

.theme--light.v-timeline:before {
  background-color: #D6BFAF;
  width: 4px;
}

/* .header-content {
  margin-left: -45px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
} */

.v-tab {
  font-size: 16px;
  font-weight: 500;
}

.v-tab.v-tab--active {
  font-size: 16px;
  font-weight: 700;
}

.content-font {
  color: #616A6B;
  font-weight: 500;
  font-size: 16px;
}

.logo_timeline {
  width: 25px;
  height: 25px;
}

.logo_timeline>img {
  max-width: 25px;
}

.text_title {
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}

.grid_half {
  display: grid;
  grid-template-columns: 45% 55%;
}

.radio_half {
  display: grid;
  grid-template-columns: 50%;
}

.v-otp-input .v-input {
  padding: 10px !important
}

.input-radius {
  border-radius: 10px;
}

.grid_radio {
  display: flex;
  justify-content: space-between;
}

.btn_width {
  width: 50%;
}

.image_half {
  display: grid;
  grid-template-columns: 40% 60%;
}

.input_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.mobile_btn {
  width: 15%;
}

.file_input_style {
  position: absolute;
  top: -25px;
  left: 265px;
  right: 0;
  bottom: 0;
}

.preview {
  border-radius: 10px;
}

.logo_admin {
  width: 80px;
  height: 80px;
}

.logo_admin>img {
  max-width: 80px;
}

.btn_width {
  width: 50%;
}

.input-radius {
  border-radius: 10px;
}

.table-data-img-center {
  display: flex;
  justify-content: center;
}

.v-data-table__wrapper>>>span {
  font-size: 50px;
}

@media only screen and (min-width: 0px)AND (max-width: 361px) {}

@media only screen and (max-width: 600px) {

  .title_page h4.breadcrumb_title_page,
  .v-tab {
    font-size: 14px !important;
  }

}

@media only screen and (min-width: 601px) AND (max-width: 960px) {}

@media only screen and (min-width: 961px) AND (max-width: 1264px) {}

@media only screen and (min-width: 1265px) AND (max-width: 1904px) {}
</style>
